<template>
  <div id="welcome-ruter">
    <ny-rute />
    <SavedTripsList
      :editingTitle="editingTitle"
      :setEditingTitle="setEditingTitle"
    />
    <InfoBoks
      v-if="showInfoBoks"
      :onClose="()=>showInfoBoks=false"
    />
    <div
      class="toggle-infoboks"
      @click="showInfoBoks = !showInfoBoks"
    >
      <Advarsel
        :width="24"
        :iconColor="'#8990B9'"
        :strokeColor="'#ECEDF4'"
      />
    </div>
  </div>
</template>

<script>
import NyRute from './NyRute.vue';
import SavedTripsList from './SavedTripsList.vue';
import InfoBoks from './InfoBoks.vue';
import Advarsel from '@/components/Icons/Advarsel.vue';
import { differenceInHours } from 'date-fns';
export default {
  name: 'ruter',
  components: { NyRute, SavedTripsList, InfoBoks, Advarsel },
  props: {
    editingTitle: [String, Number],
    setEditingTitle: Function,
  },
  data: function() {
    return { differenceInHours, showInfoBoks: false };
  },
  watch: {
    showInfoBoks: function(showInfoBoks) {
      if (showInfoBoks) {
        localStorage.setItem('infoBoksLastShown', new Date().toISOString());
      }
    },
  },

  mounted() {
    const infoBoksLastShown = localStorage.getItem('infoBoksLastShown');
    if (!infoBoksLastShown || this.shouldShowInfoBoks(infoBoksLastShown)) {
      this.showInfoBoks = true;
    }
  },
  methods: {
    shouldShowInfoBoks(infoBoksLastShown) {
      return (
        this.differenceInHours(new Date().toISOString(), infoBoksLastShown) > 24
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#welcome-ruter {
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #ecedf4;
  min-height: 100vh;
  overflow-y: auto;
  align-items: center;
  padding-top: 100px;
  padding-left: 470px;
}

.toggle-infoboks {
  cursor: pointer;
  position: fixed;
  right: 15px;
  bottom: 15px;
  z-index: 1;
}

@media only screen and (max-width: $tablet-landscape-max-width),
  screen and (max-height: 800px) {
  #welcome-ruter {
    padding-left: 320px;
    padding-top: 60px;
  }
}

@media only screen and (max-width: $tablet-max-width) {
  #welcome-ruter {
    padding-left: 0;
    min-height: 0;
    padding-bottom: 340px;
  }
}

@media only screen and (max-width: $mobile-max-width) {
  #welcome-ruter {
    padding-top: 30px;
    padding-bottom: 300px;
  }

  .toggle-infoboks {
    display: none;
  }
}
</style>
